$(document).ready(function() {
    var swiper = new Swiper('.review_col', {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      speed: 400,
      slidesPerView: 4,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        1920: {
          slidesPerView: 4,
          spaceBetween: 10
        },
        1028: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 10
        }
      }
    });


   var swiper = new Swiper('.custom-features', {
      loop: false,
      autoplay: {
        delay: 2000,
      },
      speed: 400,
      slidesPerView: 4.3,
      spaceBetween: 16,
     freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className}" style="display:none;"></span>`;
        },
      },
      breakpoints: {
        1920: {
          slidesPerView: 4,
          spaceBetween: 16
        },
        1028: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 12
        }
      }
    });


  var swiper = new Swiper('.testim_row', {
      loop: false,
      autoplay: {
        delay: 2000,
      },
      speed: 1000,
      slidesPerView: 3,
      spaceBetween: 16,
     freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        1920: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        1028: {
          slidesPerView: 2,
          spaceBetween: 12
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 12
        }
      }
    });

   if ($(window).width() < 767) {
      var swiper = new Swiper('.mobileslider', {
        loop: false,
        autoplay: {
          delay: 2000,
        },
        speed: 1000,
        slidesPerView: 1,        
        freeMode: false,      
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      });
   }

  
});
   
$('.tab-header').click(function() {
  var index = $(this).index();
  $('.tab-header').removeClass('active');
  $(this).addClass('active');
  $('.tab-pane').hide().eq(index).show();
});  

$(document).ready(function() {
  
    var swiper = new Swiper('.product_column', {
      loop: false,
      autoplay: {
        delay: 2000,
      },
      speed: 400,
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className}" style="display:none;"></span>`;
        },
      },
      breakpoints: {
        1920: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        1028: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 10
        }
      }
    });

// frequently bought together
      $("#txtArea1").change(function() {
          this.checked ? $(".image-pro1").show() : $(".image-pro1").hide()
      }),
      $("#txtArea2").change(function() {
          this.checked ? $(".image-pro2").show() : $(".image-pro2").hide()
      }),
      $("#txtArea3").change(function() {
          this.checked ? $(".image-pro3").show() : $(".image-pro3").hide()
      })

   const reviewslider = new Swiper('.reviews-slider.swiper-container', {
      slidesPerView: 3, // Number of slides to show per view
      spaceBetween: 15, // Space between slides
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // autoplay: {
      //   delay: 3000, // Slide will change every 3 seconds (3000ms)
      //   disableOnInteraction: false, // Autoplay will not stop after user interaction (like navigation clicks)
      // },
      loop: true,
     breakpoints: {
        1920: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 12
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 12
        }
      }
    });
  
  });

// anchor tag click scroll
$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 150
    }, 500);
});

// sticky add to cart
$(document).on("click",".product-form__submit_sticky",function() {    
   $('.product-form__submit_sticky').prop('disabled', true);
   $(".product-form__submit").click();
  
    setTimeout(function () {
      $('.product-form__submit_sticky').prop('disabled', false);
    }, 2500);
});

//   Bundle products
var bogoproducts = document.querySelectorAll(".variant-options-list");
let proObj = document.querySelector("[data-product-object]") ? JSON.parse(document.querySelector("[data-product-object]").innerHTML) : null;
if (bogoproducts) {
  bogoproducts.forEach(function(bogoProduct){
    var variantSelects = bogoProduct.querySelectorAll(".variant-options-list select");
    variantSelects.forEach(function(selectElement) {
      selectElement.addEventListener('change', function() {
        var selectedOption = selectElement.options[selectElement.selectedIndex];
        // var variant_id = selectedOption.getAttribute("data-id");
         var variantsElem = bogoProduct.closest(".pdp_variants");


        let variantTitle = "";
        variantSelects.forEach((select,index) => {
          variantTitle += select.value;
          if(index != (variantSelects.length - 1)){
            variantTitle += " / ";
          }
        });
        var variantBlock = bogoProduct.closest(".WidgetComponent ");
        var imageElem = variantBlock.querySelector(".image_wrapper img");
        // console.log("variantTitle",variantTitle);
        var matchedVariant = false;
        proObj?.variants.forEach(variant => {
          
          if(variant.title == variantTitle){
            matchedVariant = true;
            // console.log("variant",variant);
            let imgSrc = variant.featured_image?.src;
            var variant_id = variant.id;
            variantsElem.setAttribute("data-variant-id",variant_id);
            // console.log("imgSrc",imgSrc);
            if(imgSrc){
              imageElem.setAttribute('src',imgSrc);
            }
          }
        });
        const addToCartButton = document.querySelector(".product__info-wrapper .product-form__submit");
        if(!matchedVariant){
            
            addToCartButton.textContent = "Sold Out";
            addToCartButton.setAttribute("disabled", "disabled");
          // console.log("not matched with anyone");
        }
        else{
            addToCartButton.textContent = "👉 Add to cart";
            addToCartButton.removeAttribute("disabled");
        }
        var selectedOptionVal = selectElement.options[selectElement.selectedIndex];
        // console.log("Vrainats Object",proObj.variants);
        // console.log("Selected option",selectedOption);
       
      });
     
       // selectElement.addEventListener("click", function (event) {
       //   var optionType = selectElement.closest(".list-unstyled");
       //    console.log("optionType",optionType);
       //    var selectedOptionVal = event.target.value;

       //      if (optionType.classList.contains("option-1")){
       //        let matchingVariants = proObj.variants.filter(variant => variant.option1 === selectedOptionVal);
       //        console.log("matchingVariants",matchingVariants);
       //        let option2values = matchingVariants.map(variant => variant.option2);
       //        let option3values = matchingVariants.map(variant => variant.option3);
       //        console.log("option2values",option2values);
       //        console.log("option3values",option3values);

       //        bogoProduct.querySelectorAll(".list-unstyled.option-2 .select-option-item").forEach(label => {
       //          label.classList.remove('is-disabled');
       //          label.removeAttribute("disabled");
       //          const value = label.getAttribute('data-value');
              
       //          if (!option2values.includes(value)) {
       //              label.classList.add('is-disabled');
       //              label.setAttribute("disabled", "true"); // Use "true" instead of "disabled"
       //          }
       //        });
            
       //        bogoProduct.querySelectorAll(".list-unstyled.option-3  .select-option-item").forEach(label => {
       //            label.classList.remove('is-disabled');
       //            label.removeAttribute("disabled");
       //            const value = label.getAttribute('data-value');
                 
       //            if (!option3values.includes(value)) {
       //                label.classList.add('is-disabled');
       //                label.setAttribute("disabled", "true"); // Use "true" instead of "disabled"
       //            }
       //        });
       //      } else if(optionType.classList.contains("option-2")){
       //        let matchingVariants = proObj.variants.filter(variant => variant.option2 === selectedOptionVal);
       //        console.log("matchingVariants",matchingVariants);
       //        let option1values = matchingVariants.map(variant => variant.option1);
       //        let option3values = matchingVariants.map(variant => variant.option3);
       //        console.log("option1values",option1values);
       //        console.log("option3values",option3values);

       //        bogoProduct.querySelectorAll(".list-unstyled.option-1 .select-option-item").forEach(label => {
       //          label.classList.remove('is-disabled');
       //          label.removeAttribute("disabled");
       //          const value = label.getAttribute('data-value');
              
       //          if (!option1values.includes(value)) {
       //              label.classList.add('is-disabled');
       //              label.setAttribute("disabled", "true"); // Use "true" instead of "disabled"
       //          }
       //        });
            
       //        bogoProduct.querySelectorAll(".list-unstyled.option-3  .select-option-item").forEach(label => {
       //            label.classList.remove('is-disabled');
       //            label.removeAttribute("disabled");
       //            const value = label.getAttribute('data-value');
                 
       //            if (!option3values.includes(value)) {
       //                label.classList.add('is-disabled');
       //                label.setAttribute("disabled", "true"); // Use "true" instead of "disabled"
       //            }
       //        });
       //      } else if(optionType.classList.contains("option-3")){
       //        let matchingVariants = proObj.variants.filter(variant => variant.option3 === selectedOptionVal);
       //        console.log("matchingVariants",matchingVariants);
       //        let option1values = matchingVariants.map(variant => variant.option1);
       //        let option2values = matchingVariants.map(variant => variant.option2);
       //        console.log("option1values",option1values);
       //        console.log("option2values",option2values);

       //        bogoProduct.querySelectorAll(".list-unstyled.option-1 .select-option-item").forEach(label => {
       //          label.classList.remove('is-disabled');
       //          label.removeAttribute("disabled");
       //          const value = label.getAttribute('data-value');
              
       //          if (!option1values.includes(value)) {
       //              label.classList.add('is-disabled');
       //              label.setAttribute("disabled", "true"); // Use "true" instead of "disabled"
       //          }
       //        });
            
       //        bogoProduct.querySelectorAll(".list-unstyled.option-2 .select-option-item").forEach(label => {
       //          label.classList.remove('is-disabled');
       //          label.removeAttribute("disabled");
       //          const value = label.getAttribute('data-value');
              
       //          if (!option2values.includes(value)) {
       //              label.classList.add('is-disabled');
       //              label.setAttribute("disabled", "true"); // Use "true" instead of "disabled"
       //          }
       //        });
       //      }
       //  });
    });
  })
}



var button = document.querySelector(".custom_addTOCart .product-form__submit");
if(button){
  console.log("button",button);
  button.addEventListener("click", function(event) {
    event.preventDefault();
    // const addOnID = document.querySelector(".pdp_variants").getAttribute("data-variant-id");
    // console.log("addOnID",addOnID);
    // const productId = document.querySelector('.product-variant-id[name="id"]').value;
    // console.log("productId",productId);
    var arr = [];
    var variantElems = document.querySelectorAll(".bogo_product .pdp_variants");
    variantElems.forEach(function(variantElem){
      var variant_id = variantElem.getAttribute("data-variant-id");
      console.log("Variant_ID",variant_id);
     arr.push({ id: variant_id, quantity:1});       
    })
    console.log(arr);
     var sections = ['cart-drawer', 'cart-icon-bubble'];
    fetch(window.Shopify.routes.root +'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items:arr,
        sections: sections
      }),
    })
  .then(res => res.json())
  .then((response) => { 
    // const cartbtn = document.querySelector('#cart-icon-bubble');
    // const cartDrawer = document.querySelector('cart-drawer');
    // console.log("Added Product",response);
    // // return false;
    // cartDrawer.classList.remove('is-empty');          
    // cartDrawer.renderContents(response);
    // cartbtn.dispatchEvent(new Event("click", { bubbles: true }));
     window.opusOpen(); 
  })
    .catch(error => {
        console.error('Error:', error);
    });
  
  });
}
//   Bundle products


// discount 
// async function applyDiscountCodeToCart(cartId, discountCode, shopifyToken) {

//     const myHeaders = new Headers();
//     myHeaders.append("X-Shopify-Storefront-Access-Token", shopifyToken);
//     myHeaders.append("Content-Type", "application/json");

//     const graphql = JSON.stringify({
//         query: `
//             mutation UpdateCartDiscountCodes($cartId: ID!, $discountCodes: [String!]!) {
//                 cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
//                     cart {
//                         id
//                         discountCodes {
//                             code
//                             applicable
//                         }
//                         checkoutUrl
//                     }
//                     userErrors {
//                         code
//                         field
//                         message
//                     }
//                 }
//             }
//         `,
//         variables: {
//             "cartId": `gid://shopify/Cart/${cartId}`,
//             "discountCodes": [discountCode]
//         }
//     });

//     const requestOptions = {
//         method: "POST",
//         headers: myHeaders,
//         body: graphql,
//         redirect: "follow"
//     };

//     try {
//         const response = await fetch("/api/2024-10/graphql.json", requestOptions);
//         const result = await response.json();

//         const applicable = result.data.cartDiscountCodesUpdate.cart.discountCodes[0]?.applicable;
//         return { success: true, applicable };
//     } catch (error) {
//         console.error('Error:', error);
//         return { success: false, error };
//     }
// }

// // Function to fetch the cart token from Shopify's /cart.js endpoint
// async function getCartToken() {
//     try {
//         const response = await fetch('/cart.js');
//         const cartData = await response.json();
//         return cartData.token; // This will return the cart token
//     } catch (error) {
//         console.error("Error fetching cart:", error);
//         return null;
//     }
// }

// // Function to apply discount code
// async function appliedDiscountCode(discountCode) {
//   const myCartTokenId = await getCartToken(); // Fetch cart token
//   console.log("myCartTokenId",myCartTokenId);
//     console.log("APLLICABLE DISCOUNT",discountCode);
//   if (myCartTokenId) {
//       const cartId = decodeURIComponent(myCartTokenId);
//       const myShopifyToken = '6a6faff9cf1e9ea0e20b4c0917ee79ff';

//       const result = await applyDiscountCodeToCart(cartId, discountCode, myShopifyToken);
      
//       if (result.success && result.applicable) {
//         const discountLabel = document.querySelector(".applied_discount .valid_discount");
//         console.log("discountLabel",discountLabel);
//           discountLabel.textContent = discountCode;
//           discountLabel.closest(".applied_discount").style.display = 'block';
//           console.log(`Discount code "${discountCode}" applied successfully!`);
//           localStorage.setItem("discount_code", discountCode);
//           return result; // Exit after successfully applying one code
//       } else {
//           console.log(`Discount code "${discountCode}" is not applicable.`);
//       }
//   } else {
//       console.log("No cart token or discount code found.") ;
//       const discountLabel = document.querySelector(".applied_discount .valid_discount");
//       console.log("discountLabel",discountLabel);
//       // if(discountLabel) discountLabel.innerHTML = discountCode;
//       discountLabel.textContent = '';
//   }
// }

// // Event listener for discount button
// document.addEventListener('DOMContentLoaded', function() {
//   // document.querySelector(".applied_discount").style.display = 'none';
//   // Check if discount code is already applied 
//   var appliedDiscount = localStorage.getItem("discount_code");
//   if(appliedDiscount != null){
//       const discountLabel = document.querySelector(".applied_discount .valid_discount");
//       discountLabel.textContent = appliedDiscount;
//        document.querySelector(".applied_discount").style.display = 'block';
//   }
  
//   var discountWrapper = document.querySelector(".discount_wrapper");
//   var discountApplyButton = discountWrapper.querySelector("button");
    
//   if (discountApplyButton) {
//     discountApplyButton.addEventListener('click', function(event) {
//       event.preventDefault(); 
//       var discountInput = discountWrapper.querySelector("input");
//       var value = discountInput.value;
//       console.log("Value",value);
//       appliedDiscountCode(value); 
      
//     });
//   }


//     var removeDiscountBtn = document.querySelector(".applied_discount .remove");
//     if(removeDiscountBtn){
//       removeDiscountBtn.addEventListener('click',function(){
//          var value = '';
//         console.log("discount_code",value);
//          appliedDiscountCode(value);
//         const discountLabel = document.querySelector(".applied_discount .valid_discount");
//          discountLabel.textContent = '';
//         localStorage.removeItem("discount_code");
//          this.closest(".applied_discount").style.display = 'none';
//       });
//     }
// });

var discount_addButton = document.querySelector(".discount_wrapper .discount_add_btn");
var discount_removeBtn = document.querySelector(".discount_wrapper .discount_remove_btn");
var discountInput = document.querySelector(".discount_wrapper .discount_input");
if(discount_addButton){
  discount_addButton.addEventListener('click',function(){
    discountInput.classList.remove('hidden');
    discount_removeBtn.classList.remove('hidden');
    discount_addButton.classList.add('hidden');
  });
}

if(discount_removeBtn){
  discount_removeBtn.addEventListener('click',function(){
     discountInput.classList.add('hidden');
    discount_addButton.classList.remove('hidden');
    discount_removeBtn.classList.add('hidden');
  });
}



